import { useTranslation } from 'react-i18next';

const MISSION_IMG = 'http://geel.fp.08wx.cn/images/e2a34b493fcd751e10659e0f20bc9ac5.jpg';

export default function MissionSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-white py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 xl:gap-24 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden border border-primary/15">
              <div className="w-full h-[520px]">
                <img src={MISSION_IMG} alt="Mission" className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-white/60 via-white/10 to-transparent" />
              </div>
              <div className="absolute top-6 right-6 bg-white/95 border border-primary/20 rounded-xl px-5 py-4 backdrop-blur-sm">
                <div className="text-primary text-2xl font-heading font-black">{t('aboutPage.hero.stats.0.val')}</div>
                <div className="text-gray-400 text-xs mt-1">{t('aboutPage.mission.badge')}</div>
              </div>
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 border border-primary/15 rounded-xl px-5 py-4 backdrop-blur-sm">
                <div className="text-gray-800 text-sm font-medium mb-2">{t('aboutPage.mission.cardTitle')}</div>
                <div className="text-gray-500 text-xs leading-relaxed">
                  {t('aboutPage.mission.cardDesc1')}<br />
                  {t('aboutPage.mission.cardDesc2')}
                </div>
              </div>
            </div>
            <div className="absolute -bottom-4 -right-4 w-28 h-28 border-r-2 border-b-2 border-primary/20 rounded-br-2xl" />
            <div className="absolute -top-4 -left-4 w-28 h-28 border-l-2 border-t-2 border-accent/20 rounded-tl-2xl" />
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <i className="ri-seedling-line text-primary text-sm" />
              <span className="text-primary text-xs font-medium uppercase tracking-wider">{t('aboutPage.mission.tag')}</span>
            </div>

            <h2 className="text-4xl xl:text-5xl font-heading font-bold text-gray-900 mb-8 leading-tight">
              {t('aboutPage.mission.title1')}<br />
              <span className="text-primary">{t('aboutPage.mission.title2')}</span>
            </h2>

            <div className="space-y-5 mb-10">
              <p className="text-gray-600 text-base leading-relaxed">
                {t('aboutPage.mission.p1')}
              </p>
              <p className="text-gray-500 text-base leading-relaxed">
                {t('aboutPage.mission.p2')}
              </p>
              <p className="text-gray-500 text-base leading-relaxed">
                {t('aboutPage.mission.p3.prefix')}<strong className="text-primary">{t('aboutPage.mission.p3.strong')}</strong>{t('aboutPage.mission.p3.suffix')}
              </p>
            </div>

            <div className="space-y-4">
              {Array.from({ length: 5 }, (_, i) => ({
                year: t(`aboutPage.mission.timeline.${i}.year`),
                event: t(`aboutPage.mission.timeline.${i}.event`),
              })).map((item, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="flex flex-col items-center flex-shrink-0">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary mt-1.5" />
                    {i < 4 && <div className="w-px h-8 bg-primary/20 mt-1" />}
                  </div>
                  <div className="pb-1">
                    <span className="text-primary text-xs font-mono font-bold mr-3">{item.year}</span>
                    <span className="text-gray-500 text-sm">{item.event}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
